import { useState } from "react";
import "../styles/feedback.css";
import TextareaAutosize from "react-textarea-autosize";
import Icon from "components/Icon";
import axios from "axios";
import { useSelector } from "react-redux";

enum STEPS {
  SHOW_FEEDBACK,
  SHOW_TERMINATE,
  SHOW_OPTIONS,
  SHOW_REASON
}

const feedbackOptions = {
  "polite & helpful": false,
  "satisfactory resolution": false,
  "Quick resolution": false,
  "Seamless experience": false
};
type ChatFeedbackProps = {
  isFeedbackSubmitted: string | null;
  isMakeoBuddy: boolean;
  messageId: string;
  chatId: string;
  setIsFeedbackSession: (value: boolean) => void;
};
const ChatFeedback = ({
  isFeedbackSubmitted,
  isMakeoBuddy,
  messageId,
  chatId,
  setIsFeedbackSession
}: ChatFeedbackProps) => {
  const [step, setStep] = useState(
    isFeedbackSubmitted ? STEPS.SHOW_TERMINATE : STEPS.SHOW_FEEDBACK
  );
  const [likeDislike, setLikeDislike] = useState("");
  const [terminateContent, setTerminateContent] = useState(
    isFeedbackSubmitted === "positive"
      ? "Thank you for your valuable feedback.<br /><br />We look forward to serving you again.<br /><br />Keep smiling😁"
      : "We apologize that your query was not resolved.<br/><br/>We look forward to serving you again.<br/><br/>Keep Smiling😁"
  );
  const [feedbackContent, setFeedbackContent] = useState("");
  const [skip, setSkip] = useState(isMakeoBuddy);
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [error, setError] = useState(false);
  const userInfo = useSelector((state: any) => state?.chatInfoReducer?.user);

  const submitFeedBack = async (isHelpful: boolean, feedback?: string) => {
    try {
      const response = await axios.post(
        "/api/v2/chatapp/makeo/update-feedback",
        {
          messageId: messageId,
          toothsiUserId: userInfo?.customerId,
          isHelpful: isHelpful,
          conversationId: chatId,
          feedback: feedback || ""
        }
      );
      setIsFeedbackSession(false);
      return response?.data?.isSuccess;
    } catch (error) {
      console.log();
      setError(true);
    }
  };

  const handleLike = async () => {
    setLikeDislike("LIKE");
    if (isMakeoBuddy) {
      await submitFeedBack(true);
      setTerminateContent(
        "Thank you for your valuable feedback.<br /><br />We look forward to serving you again.<br /><br />Keep smiling😁"
      );
      setStep(STEPS.SHOW_TERMINATE);
    } else {
      setStep(STEPS.SHOW_OPTIONS);
    }
  };

  const handleDislike = () => {
    setLikeDislike("DISLIKE");
    setStep(STEPS.SHOW_REASON);
  };

  const handleFeedbackSubmission = async () => {
    const isPositive = step === STEPS.SHOW_OPTIONS;
    const feedbackPoints = isPositive
      ? Object.keys(checkedItems)
          .filter((key) => checkedItems[key])
          .join(", ")
      : "";
    const isSuccess = await submitFeedBack(
      isPositive,
      isPositive ? feedbackPoints : feedbackContent
    );
    /* if (isSuccess && isMakeoBuddy && !skip) {
      try {
        await axios.post("/api/v2/chatapp/makeo/assign-chat-to-smile-buddy", {
          chatId: chatId,
          category: "Complaint Customer Support",
          subCategory: "",
          description: feedbackContent
        });
      } catch (error) {
        console.log();
        setError(true);
      }
    } */
    setStep(STEPS.SHOW_TERMINATE);
    isPositive
      ? setTerminateContent(
          "Thank you for your valuable feedback.<br /><br />We look forward to serving you again.<br/><br/>Keep smiling😁"
        )
      : setTerminateContent(
          "We apologize that your query was not resolved.<br/><br/>We look forward to serving you again.<br/><br/>Keep Smiling😁"
        );
  };

  const handleFeedbackChange = (eve: any) => {
    setFeedbackContent((prev) => {
      prev = eve.target.value;
      if (prev.length > 0 && skip) {
        setSkip(false);
      } else if (prev.length === 0 && !skip && isMakeoBuddy) {
        setSkip(true);
      }
      return prev;
    });
  };

  const handleCheckboxChange = (selectedOption: string) => {
    setCheckedItems((prev) => ({
      ...prev,
      [selectedOption]: !prev[selectedOption]
    }));
  };

  const landingScreen = (
    <>
      <p className="fed__content">
        We hope, we were able to resolve your queries.please tell us how was
        your conversation experience
      </p>
      <div className="fed-btn-grp">
        <button
          type="button"
          className={`fed-btn ${likeDislike === "LIKE" ? "positive" : ""}`}
          onClick={handleLike}
        >
          {likeDislike === "LIKE" ? (
            <Icon id="activeLike" />
          ) : (
            <Icon id="like" />
          )}
        </button>
        <button
          type="button"
          className={`fed-btn ${likeDislike === "DISLIKE" ? "negative" : ""}`}
          onClick={handleDislike}
        >
          {likeDislike === "DISLIKE" ? (
            <Icon id="activeDislike" />
          ) : (
            <Icon id="dislike" />
          )}
        </button>
      </div>
    </>
  );

  const renderContent = () => {
    switch (step) {
      case STEPS.SHOW_FEEDBACK:
        return landingScreen;

      case STEPS.SHOW_REASON:
        return (
          <>
            <p className="fed__content">
              We hope, we were able to resolve your queries.please tell us how
              was your conversation experience
            </p>

            <TextareaAutosize
              className="fed__input"
              placeholder="share your feedback"
              value={feedbackContent}
              onChange={handleFeedbackChange}
            />

            <button
              type="button"
              className={`fed__skip ${!skip ? "active" : ""}`}
              onClick={handleFeedbackSubmission}
            >
              {skip ? "skip this step" : "submit"}
            </button>
          </>
        );
      case STEPS.SHOW_OPTIONS:
        return (
          <>
            {landingScreen}
            <p className="fed__content">
              your feedback will help us serve you better
            </p>
            <div className="fed__inp-grp">
              {Object.entries(feedbackOptions).map(([option, value], indx) => (
                <div
                  className="fed__ch-box"
                  key={indx}
                  onClick={() => handleCheckboxChange(option)}
                >
                  <label className="fed__ch-box--label" key={indx}>
                    {option}
                  </label>
                  {checkedItems[option] && (
                    <img
                      src="https://assets.toothsi.in/check_d3820c5eb5.svg"
                      alt="#"
                      className="fed__checkmark"
                    />
                  )}
                </div>
              ))}
            </div>
            <button className="fed__frm-btn" onClick={handleFeedbackSubmission}>
              submit feedback
            </button>
          </>
        );
      case STEPS.SHOW_TERMINATE:
        return (
          <p
            className="fed__content"
            dangerouslySetInnerHTML={{ __html: terminateContent }}
          ></p>
        );
    }
  };

  return (
    <div className="root">
      <div className="root__wrapper">
        <div className="fed-container">{renderContent()}</div>
      </div>
    </div>
  );
};

export default ChatFeedback;
